import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class HoverService {
  public hoverEmitterSet: {[id: string]: EventEmitter<{datasetIndex: number, index: number, trigger: string}>} = {}

  constructor() { }

  public getEmitter(id: string): EventEmitter<{datasetIndex: number, index: number, trigger: string}> {
    if(this.hoverEmitterSet[id] === undefined) {
      this.hoverEmitterSet[id] = new EventEmitter<{datasetIndex: number, index: number, trigger: string}>();
    }
    return this.hoverEmitterSet[id];
  }

  public registerEmitter(id: string): EventEmitter<{datasetIndex: number, index: number, trigger: string}> {
    this.hoverEmitterSet[id] = new EventEmitter<{datasetIndex: number, index: number, trigger: string}>();
    return this.hoverEmitterSet[id];
  }

  public unregisterEmitter(id: string) {
    if(this.hoverEmitterSet[id] !== undefined) {
      delete this.hoverEmitterSet[id];
    }
  }
}
